export default __webpack_public_path__ + "static/media/return-package.d075788a.svg";